var _symbol, _g, _use, _use2, _use3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindmill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 189.326 283.989",
    style: {
      background: "transparent"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "blade"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    id: "blade-front",
    d: "M14.6491879,1.85011601 C14.2684455,-0.0535962877 10.7150812,-0.815081206 9.06473318,3.37308585 L0.434338747,70.7658933 L8.93805104,91.9607889 L15.4106729,90.437819 L17.5684455,78.3807425 L14.5218097,1.97679814 L14.6491879,1.85011601 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a0a6a7",
    id: "blade-side",
    d: "M11.0951276,0.581206497 C10.3336427,0.961948956 9.57215777,1.85011601 8.93735499,3.24640371 L0.306960557,70.6392111 L8.81067285,91.8341067 L3.35359629,70.0044084 L11.0951276,0.581206497 Z"
  }))), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "structure",
    transform: "translate(58.123, 82.664)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "tower",
    fill: "#fff",
    points: "33.111,10.984 39.965,10.984 44.28,196.176 28.796,196.176"
  }), /*#__PURE__*/React.createElement("path", {
    id: "yaw",
    fill: "rgba(0,0,0,0.25)",
    d: "M40.3454756,23.2948956 L40.7262181,34.8445476 C38.8225058,35.0986079 35.7765661,35.0986079 32.349884,34.337123 L32.7306265,23.2955916 L40.3454756,23.2955916 L40.3454756,23.2948956 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "base",
    fill: "#a0a6a7",
    transform: "translate(0 42)",
    d: "M26.3846868,150.591647 L46.5640371,150.591647 C48.8484919,150.591647 50.7522042,152.49536 50.7522042,154.779814 L50.7522042,158.967981 L22.0691415,158.967981 L22.0691415,154.779814 C22.0691415,152.49536 23.9728538,150.591647 26.2573086,150.591647 L26.3846868,150.591647 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nacelle",
    fill: "#fff",
    cx: 36.54,
    cy: 12,
    r: 11.93
  }), /*#__PURE__*/React.createElement("circle", {
    id: "gearbox",
    fill: "none",
    stroke: "#a0a6a7",
    strokeWidth: 2.75,
    cx: 36.538,
    cy: 11.999,
    r: 5.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "wind-blade",
    style: {
      animation: "2s linear 0s infinite normal none running spin"
    }
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "blade1",
    href: "#blade",
    x: 83.24,
    y: 0
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    id: "blade2",
    href: "#blade",
    x: 83.24,
    y: 0,
    transform: "rotate(120 94.663 94.663)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    id: "blade3",
    href: "#blade",
    x: 83.24,
    y: 0,
    transform: "rotate(-120 94.663 94.663)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindmill);
export default __webpack_public_path__ + "static/media/windmill.86266fc1b679ce0d78bc90c2eb042d98.svg";
export { ForwardRef as ReactComponent };